export default class Holding {
	constructor() {
		this.HoldingName = null;
		this.RegisteredOwner = null;
		this.HoldingIdentificationNumber = null;
		this.documentList = [];
	}
}
